import { render } from "./EditOffboarding.vue?vue&type=template&id=352c6746&scoped=true"
import script from "./EditOffboarding.vue?vue&type=script&lang=js"
export * from "./EditOffboarding.vue?vue&type=script&lang=js"

import "./EditOffboarding.vue?vue&type=style&index=0&id=352c6746&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352c6746"]])

export default __exports__